"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { useStyles } from "../../../core/styles-api/use-styles/use-styles.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import Input_module_default from "../Input.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Input/InputPlaceholder/InputPlaceholder.tsx
const InputPlaceholder = factory((_props) => {
	const props = useProps("InputPlaceholder", null, _props);
	const { classNames, className, style, styles, unstyled, vars, __staticSelector, error, mod, attributes, ...others } = props;
	return /* @__PURE__ */ jsx(Box, {
		...useStyles({
			name: ["InputPlaceholder", __staticSelector],
			props,
			classes: Input_module_default,
			className,
			style,
			classNames,
			styles,
			unstyled,
			attributes,
			rootSelector: "placeholder"
		})("placeholder"),
		mod: [{ error: !!error }, mod],
		component: "span",
		...others
	});
});
InputPlaceholder.classes = Input_module_default;
InputPlaceholder.displayName = "@mantine/core/InputPlaceholder";
//#endregion
export { InputPlaceholder };

//# sourceMappingURL=InputPlaceholder.mjs.map